package com.milta.core.localization.translations.de

import com.milta.core.localization.WebHistoriqueStrings

// MIL-52 — genuinely translated (same convention as Settings.kt in this package, see De.kt remarks).
internal val WebHistorique = WebHistoriqueStrings(
    screenATitle = "Tourenverlauf",
    periodLabel = "Zeitraum",
    periodLastEightDays = "Letzte 8 Tage",
    periodSingleDate = "Bestimmtes Datum",
    periodRange = "Datumsbereich",
    rangeFromLabel = "Von",
    rangeToLabel = "Bis",
    driverFilterLabel = "Fahrer",
    driverFilterAllOption = "Alle Fahrer",
    columnDate = "Datum",
    columnDriver = "Fahrer",
    columnTotalDeliveries = "Lieferungen gesamt",
    columnDelivered = "Zugestellt",
    columnFailed = "Fehlgeschlagen",
    viewProofsAction = "Nachweise ansehen",
    emptyHistoryMessage = "Für diesen Zeitraum wurden keine Touren gefunden.",
    errorInvalidPeriod = "Der ausgewählte Zeitraum ist ungültig.",
    screenBTitle = "Verlauf der Zustellnachweise",
    routeOfLabel = "Tour vom",
    totalDeliveriesLabel = "Lieferungen",
    deliveredLabel = "zugestellt",
    failedLabel = "fehlgeschlagen",
    backToHistoryAction = "Tourenverlauf",
    statusDeliveredBadge = "Zugestellt",
    statusFailedBadge = "Fehlgeschlagen",
    viewReasonAction = "Grund anzeigen",
    hideReasonAction = "Grund ausblenden",
    photoPlaceholderAlt = "Kein Foto verfügbar",
    photoAlt = "Zustellnachweis",
    emptyProofsMessage = "Für diese Tour ist kein Zustellnachweis verfügbar.",
    paginationPrevious = "Zurück",
    paginationNext = "Weiter",
)
